import { DomainInfo } from '_backend/integration/domain-info';
import { AnchorType } from '_types/public-api';

export const getLocalizedUrl = (link: AnchorType) => {
  const linkDomainInfo = DomainInfo.getFromOrigin(`https://${link.host}`);

  const protocol = process.env.NODE_ENV === 'development' ? 'http' : 'https';
  return linkDomainInfo?.getMainLocale() === link.locale
    ? `${protocol}://${link.host}${link.link}`
    : `${protocol}://${link.host}/${link.locale}${link.link}`;
};

export const sortLinks = (links?: AnchorType[]) => links?.sort((a, b) => a.position - b.position) ?? [];
